import React, { useEffect, useState } from "react";
import nav from "./Nav.module.css";
import Logo from "../../img/logo 1.png";
import ToggleButton from "../../Contexts/darkmode/ToggleButton";
import Weather from "../../Contexts/Weather/Weathers";
import Searchs from "../../Contexts/Search/Search";
import { BiMenuAltRight } from "react-icons/bi";
import { getAllPostsCategories } from "../../Api/PostManApi";
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";

const Nav = () => {
  const [isclose, setIsclose] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const postCategories = async () => {
      const data = await getAllPostsCategories();

      setCategories(data);
    };
    postCategories();
    // console.log(categories);
  }, []);

  const ToggleButtons = () => {
    setIsclose(!isclose);
  };

  return (
    <div className={nav.nav}>
      <div className={nav.container}>
        <div className={nav.content}>
          <div className={nav.logo}>
            <img src={Logo} alt="" />
            <Link to="/">
              <h3>
                TECH<span>PRESSION</span>
              </h3>
            </Link>
          </div>
          <ul className={nav.menu}>
            <li>
              <Link to="/TechTV">Tech TV</Link>
            </li>
            <li>
              <Link to="/events">Events</Link>
            </li>
            <li>
              <Link to="/category/Tech News">Tech News</Link>
            </li>
            <li>
              <Link to="/category/Cryptocurrency">Cryptocurrency</Link>
            </li>
            {/* <li>
              <Link to="/category/politics">Politics</Link>
            </li>
            <li>
              <Link to="/category/health">Health</Link>
            </li> */}
          </ul>
          <div className={nav.dark}>
            <ToggleButton />
          </div>
          <div className={nav.time}>
            <Weather />
          </div>
          <div className={nav.search}>
            <Searchs />
          </div>

          <ul className={`${nav.menuII} ${isclose ? nav.active : ""}`}>
            <div className={nav.flex}>
              <div className={nav.gridI}>
                <li>
                  <Link to="/TechTV">Tech TV</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>

                {categories.length > 0 ? (
                  categories.slice(0, 5).map((category, index) => (
                    <li key={index}>
                      {/* {category} */}
                      <Link
                        to={`/category/${category}`}
                        state={{ category: category }}
                      >
                        {category}
                      </Link>
                    </li>
                  ))
                ) : (
                  <>
                    <li>
                      <Link to="/Article">Politics</Link>
                    </li>
                    <li>
                      <Link to="/health">Health</Link>
                    </li>
                    <li>
                      <Link to="/world">World</Link>
                    </li>
                  </>
                )}
              </div>
              <div className={nav.gridII}>
                {categories.length > 0 ? (
                  categories.slice(5, 10).map((category, index) => (
                    <li key={index}>
                      {/* {category} */}
                      <Link
                        to={`/category/${category}`}
                        state={{ category: category }}
                      >
                        {category}
                      </Link>
                    </li>
                  ))
                ) : (
                  <>
                    <li>
                      <Link to="/entertainment">Entertainment</Link>
                    </li>
                    <li>
                      <Link to="/finance">Finance</Link>
                    </li>
                    <li>
                      <Link to="/sports">Sports news</Link>
                    </li>
                    <li>
                      <Link to="/startups">Startup business</Link>
                    </li>
                    <li>
                      <Link to="/trending">Trending news</Link>
                    </li>
                  </>
                )}
              </div>
              <div className={nav.gridIII}>
                {categories.length > 0 ? (
                  categories.slice(10).map((category, index) => (
                    <li key={index}>
                      {/* {category} */}
                      <Link
                        to={`/category/${category}`}
                        state={{ category: category }}
                      >
                        {category}
                      </Link>
                    </li>
                  ))
                ) : (
                  <>
                    <li>
                      <Link to="/culture">Culture and Trends</Link>
                    </li>
                    <li>
                      <Link to="/weather">Weather</Link>
                    </li>
                    <li>
                      <Link to="/local">Local news</Link>
                    </li>
                    <li>
                      <Link to="/technology">Technology</Link>
                    </li>
                    <li>
                      <Link to="/category/cryptocurrency">
                        Cryptocurrency news
                      </Link>
                    </li>
                  </>
                )}
              </div>
            </div>
            <div className={nav.flexI}>
              {/* <li>
                <Link to="/contact">Contact Us</Link>
              </li> */}
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/">Newsletter</Link>
              </li>
            </div>
          </ul>
          <div className={nav.toggle} onClick={ToggleButtons}>
            {!isclose ? (
              <BiMenuAltRight className={nav.toggle} />
            ) : (
              <IoClose className={nav.toggle} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
